fragment DraftFields on Draft {
  id
  text
  platform
  mentions
}
